/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: joaobaltieri (https://sketchfab.com/joaobaltieri)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/lowpoly-toon-characters-free-demo-animations-f774333ab1b6400288a069b12d582555
Title: Lowpoly Toon Characters (Free Demo + Animations)
*/

import React, { useRef, useEffect } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";

export function BoyModel(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF("/lowpoly_boy.glb");
  const { actions } = useAnimations(animations, group);
  //   console.log(animations) 

  useEffect(() => {
    if (props.isJumping) {
      actions["Jump"]?.play(); // Replace "Idle" with the correct animation name
    } else {
      actions["Jump"]?.stop();
      actions["Run"]?.play();
    }
  }, [props.isJumping]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <group
          name="Sketchfab_model"
          rotation={[-Math.PI / 2, 0, Math.PI]}
          scale={1.649}
        >
          <group
            name="24a835d65b1e4a4d8c1f37245e381b5efbx"
            rotation={[Math.PI / 2, 0, 0]}
          >
            <group name="Object_2">
              <group name="RootNode">
                <group name="Toon_Character_Armature">
                  <group name="Object_5">
                    <primitive object={nodes._rootJoint} />
                    <skinnedMesh
                      name="Object_36"
                      geometry={nodes.Object_36.geometry}
                      material={materials.base_material_primary}
                      skeleton={nodes.Object_36.skeleton}
                    />
                    <skinnedMesh
                      name="Object_38"
                      geometry={nodes.Object_38.geometry}
                      material={materials.base_material_primary}
                      skeleton={nodes.Object_38.skeleton}
                    />
                    <skinnedMesh
                      name="Object_40"
                      geometry={nodes.Object_40.geometry}
                      material={materials.base_material_primary}
                      skeleton={nodes.Object_40.skeleton}
                    />
                    <skinnedMesh
                      name="Object_42"
                      geometry={nodes.Object_42.geometry}
                      material={materials.base_material_primary}
                      skeleton={nodes.Object_42.skeleton}
                    />
                    <skinnedMesh
                      name="Object_44"
                      geometry={nodes.Object_44.geometry}
                      material={materials.base_material_primary}
                      skeleton={nodes.Object_44.skeleton}
                    />
                    <skinnedMesh
                      name="Object_45"
                      geometry={nodes.Object_45.geometry}
                      material={materials.base_material_secondary}
                      skeleton={nodes.Object_45.skeleton}
                    />
                    <skinnedMesh
                      name="Object_47"
                      geometry={nodes.Object_47.geometry}
                      material={materials.base_material_primary}
                      skeleton={nodes.Object_47.skeleton}
                    />
                    <skinnedMesh
                      name="Object_48"
                      geometry={nodes.Object_48.geometry}
                      material={materials.base_material_tertiary}
                      skeleton={nodes.Object_48.skeleton}
                    />
                    <skinnedMesh
                      name="Object_49"
                      geometry={nodes.Object_49.geometry}
                      material={materials.base_material_secondary}
                      skeleton={nodes.Object_49.skeleton}
                    />
                    <group name="Object_35" />
                    <group name="Object_37" />
                    <group name="Object_39" />
                    <group name="Object_41" />
                    <group name="Object_43" />
                    <group name="Object_46" />
                  </group>
                </group>
                <group name="shirt_01" />
                <group name="shoes_01" />
                <group name="body" />
                <group name="shorts_01" />
                <group name="socks_01" />
                <group name="baseball_cap_01" />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/lowpoly_boy.glb");
